// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M22 2H2V15H22V2ZM16.5 7L12.0001 11.5L7.5 7H16.5Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M22 22V17H2V22H22Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-expand-down-filled')
export default class ExpandDownFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'expand-down-filled',
    }
  }
}
